export class NADAboutNADPlus {
  private element: HTMLElement;
  private observer: IntersectionObserver | null = null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.init();
  }

  private init(): void {
    this.setupFadeAnimation();
  }

  private setupFadeAnimation(): void {
    // Set up intersection observer for fade-in animation
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );

    // Observe the main section element
    this.observer.observe(this.element);
  }

  public destroy(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  public static initializeAll(): void {
    const sections = document.querySelectorAll('.nad-about-nad-plus');
    const instances: NADAboutNADPlus[] = [];

    sections.forEach(section => {
      if (section instanceof HTMLElement) {
        instances.push(new NADAboutNADPlus(section));
      }
    });

    // Store instances for potential cleanup
    (window as any).nadAboutNADPlusInstances = instances;
  }
}
